/* Sheepskinhouse quantity ladder (port of Nordicsheep ns-gift.js v2.1 to the Hyper theme).
   Cumulative: 2+ items = free shipping (Shopify automatic discount, not handled here)
   3+ items = + free brush (GIFT1), 4+ items = + free dryer balls (GIFT2), 5+ = 10% (automatic, min 7 units incl. gifts)
   Counts REAL items only: gift lines (property _free_gift) and the gift variants themselves never count.
   After every cart mutation the cart is reconciled; UI is refreshed via Hyper's `cart:refresh` event. */
(function () {
  var GIFTS = [
    { min: 3, variant: 54755968090450 },
    { min: 4, variant: 54755968254290 }
  ];
  var EXCLUDED_VARIANTS = [54755968090450, 54755968254290];
  var PROP = '_free_gift';
  var busy = false, again = false;

  function cartState(cart) {
    var giftLines = [], qty = 0, present = {};
    (cart.items || []).forEach(function (it) {
      present[it.variant_id] = true;
      if (it.properties && it.properties[PROP]) { giftLines.push(it); return; }
      if (EXCLUDED_VARIANTS.indexOf(it.variant_id) !== -1) return;
      qty += it.quantity;
    });
    return { giftLines: giftLines, qty: qty, present: present };
  }
  function getMap(k) { try { var m = JSON.parse(sessionStorage.getItem(k) || '{}'); return (m && typeof m === 'object') ? m : {}; } catch (e) { return {}; } }
  function setMap(k, m) { try { sessionStorage.setItem(k, JSON.stringify(m)); } catch (e) {} }

  function refreshUI() {
    try {
      if (/\/cart\/?$/.test(location.pathname)) { window.location.reload(); return; }
      var drawer = document.querySelector('cart-drawer');
      var open = !!(drawer && drawer.classList.contains('open')) || !!(drawer && drawer.hasAttribute('open'));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: open } }));
      fetch('/cart.js?ssh_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    } catch (e) { console.log('ssh-gift refreshUI', e); }
  }
  function mutate(url, payload) {
    return fetch(url + '?ssh_gift=1', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function finish() { busy = false; if (again) { again = false; setTimeout(reconcile, 120); } }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js?ssh_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart), added = getMap('sshGiftAdded'), dismissed = getMap('sshGiftDismissed');
      GIFTS.forEach(function (g) {
        var k = String(g.variant), earned = st.qty >= g.min;
        if (!earned) { delete dismissed[k]; delete added[k]; return; }
        if (added[k] && !st.present[g.variant]) dismissed[k] = 1;
      });
      var ops = [];
      st.giftLines.forEach(function (gl) {
        var gift = null;
        GIFTS.forEach(function (g) { if (g.variant === gl.variant_id) gift = g; });
        if (!gift || st.qty < gift.min) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });
      var adds = [];
      GIFTS.forEach(function (g) { var k = String(g.variant); if (st.qty >= g.min && !st.present[g.variant] && !dismissed[k]) adds.push(g); });
      var chain = Promise.resolve(null);
      ops.forEach(function (op) { chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); }); });
      adds.forEach(function (g) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: g.variant, quantity: 1, properties: props }).then(function (json) { if (json) added[String(g.variant)] = 1; return json; });
        });
      });
      chain.then(function () {
        setMap('sshGiftAdded', added); setMap('sshGiftDismissed', dismissed);
        if (ops.length || adds.length) refreshUI();
        finish();
      }).catch(finish);
    }).catch(finish);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try { if (CART_MUTATION.test(url) && url.indexOf('ssh_gift=1') === -1) p.then(function () { setTimeout(reconcile, 150); }, function () {}); } catch (e) {}
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) { this.__sshUrl = url; return origOpen.apply(this, arguments); };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try { var u = this.__sshUrl || ''; if (CART_MUTATION.test(u) && u.indexOf('ssh_gift=1') === -1) this.addEventListener('load', function () { setTimeout(reconcile, 150); }); } catch (e) {}
    return origSend.apply(this, arguments);
  };
  /* quick-add buttons rendered by ssh-incentive (cart context) */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ssh-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v || b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    mutate('/cart/add.js', { id: v, quantity: 1 }).then(function (json) { b.classList.remove('is-busy'); if (json) { refreshUI(); setTimeout(reconcile, 200); } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 300); });
  else setTimeout(reconcile, 300);
})();
